import { Constants } from '../../shared/Constants.js';

/**
 * Year (decade) grid rendering.
 */
export function renderYears(picker) {
  const $ = window.jQuery;
  const GDT = window.GenericDateTime;
  const $grid = $('<div class="gdp-years-grid"></div>');
  const year = picker.state.viewDate.getFullYear();
  const startYear = Math.floor(year / 10) * 10;

  for (let i = startYear - 1; i <= startYear + 10; i++) {
    const isSelected = i === picker.state.currentDate.getFullYear();
    const isOut = i < startYear || i > startYear + 9;

    let isFiltered = picker.config.filters.year && !picker.config.filters.year(i);

    if (picker.config.min && i < GDT.from(picker.config.min).get('year')) isFiltered = true;
    if (picker.config.max && i > GDT.from(picker.config.max).get('year')) isFiltered = true;

    const $year = $(
      `<div class="gdp-year-item ${isSelected ? 'selected' : ''} ${isOut ? 'gdp-day-out' : ''} ${
        isFiltered ? 'disabled' : ''
      }">${i}</div>`,
    );

    if (!isFiltered) {
      $year.on('click', () => {
        picker.state.viewDate.setFullYear(i);
        if (picker.config.components.month) {
          picker.state.view = Constants.Views.MONTHS;
          picker._updateContent();
        } else {
          picker.state.currentDate.setFullYear(i);
          picker._selectDate();
        }
      });
    }
    $grid.append($year);
  }

  return $grid;
}
